import { render } from "./datiLead.vue?vue&type=template&id=055834c2&ts=true"
import script from "./datiLead.vue?vue&type=script&lang=ts"
export * from "./datiLead.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__